module.exports = __webpack_public_path__ + "static/media/upload-video.5f658600.svg";